import { ISSUE_CONSTANT } from '../constants/IssueConstants';
import { APP_CONSTANT } from 'js/app/constants/AppConstants';

const initialState = {
};

const IssueConfigReducer = (state = initialState, action) => {
    switch (action.type) {
        case ISSUE_CONSTANT.LOAD_ISSUE_CONFIG:
            return {
                ...state,
                issueConfig: {
                    config: action.payload.data,
                    reloadForm: false
                }
            }
        case ISSUE_CONSTANT.SET_FROM_DRITY_FLAG:
            return {
                ...state,
                issueConfig: {
                    ...state.issueConfig,
                    isDirty: action.isDirty
                }
            }
        case ISSUE_CONSTANT.CHANGE_IC_CARD_TYPE:
            return {
                ...state,
                issueConfig: {
                    ...state.issueConfig,
                    config: {
                        ...state.issueConfig.config,
                        cardtype: action.cardCode
                    }
                }
            }
        case ISSUE_CONSTANT.CHANGE_IC_DESC:
            return {
                ...state,
                issueConfig: {
                    ...state.issueConfig,
                    config: {
                        ...state.issueConfig.config,
                        description: action.description
                    }
                }
            }
        case ISSUE_CONSTANT.CHANGE_ALLOWED_EMAIL_IDS: 
            return {
                ...state,
                issueConfig: {
                    ...state.issueConfig,
                    config: {
                        ...state.issueConfig.config,
                        allowedEmailIds: action.emails
                    }
                }
            }
        case ISSUE_CONSTANT.UPDATE_DESCRIPTION_CONTROL_TYPE:
            return {
                ...state,
                issueConfig: {
                    ...state.issueConfig,
                    config: {
                        ...state.issueConfig.config,
                        descriptionControlType: action.controlType
                    }
                }
            }
        case ISSUE_CONSTANT.CHANGE_IC_POS:
            return {
                ...state,
                issueConfig: {
                    ...state.issueConfig,
                    config: {
                        ...state.issueConfig.config,
                        position: action.position
                    }
                }
            }
        case ISSUE_CONSTANT.CHANGE_TRIGGER_TEXT:
            return {
                ...state,
                issueConfig: {
                    ...state.issueConfig,
                    config: {
                        ...state.issueConfig.config,
                        triggertext: action.triggertext
                    }
                }
            }
        case ISSUE_CONSTANT.CHANGE_TRIGGER_FONT_COLOR:
            return {
                ...state,
                issueConfig: {
                    ...state.issueConfig,
                    config: {
                        ...state.issueConfig.config,
                        triggerfontcolor: action.color
                    }
                }
            }
        case ISSUE_CONSTANT.CHANGE_TRIGGER_BG_COLOR:
            return {
                ...state,
                issueConfig: {
                    ...state.issueConfig,
                    config: {
                        ...state.issueConfig.config,
                        triggerbgcolor: action.color
                    }
                }
            }
        case ISSUE_CONSTANT.POPULATE_CUSTOM_FIELDS:
            return {
                ...state,
                issueConfig: {
                    ...state.issueConfig,
                    config: {
                        ...state.issueConfig.config,
                        customFields: action.customFields
                    }
                }
            }
        case ISSUE_CONSTANT.SET_FIELD_SELECTION:
            return {
                ...state,
                issueConfig: {
                    ...state.issueConfig,
                    config: {
                        ...state.issueConfig.config,
                        customFields: state.issueConfig.config.customFields.map( field => {
                            return {
                                ...field,
                                selectedType: action.fieldName === field.fieldName ? action.selectedType : field.selectedType
                            }
                        })
                    }
                }
            }
        case ISSUE_CONSTANT.REORDER_CUSTOM_FIELD:
            return {
                ...state,
                issueConfig: {
                    ...state.issueConfig,
                    config: {
                        ...state.issueConfig.config,
                        customFields: state.issueConfig.config.customFields.map( field => {
                            return {
                                ...field,
                                order: action.fieldName === field.fieldName ? action.order : 
                                    action.selectedType === field.selectedType && field.order >= action.order ? field.order + 1 : 
                                    field.order === undefined ? 0 : field.order
                            }
                        })
                    }
                }
            }
        case ISSUE_CONSTANT.UPDATE_ISSUE_COLLECTOR_CONFIG:
            const icconfig = state.issueConfig ? state.issueConfig.config : {};

            return {
                ...state,
                issueConfig: {
                    ...state.issueConfig,
                    config: {
                        ...icconfig,
                        ...action.config
                    }
                }
            }
        case ISSUE_CONSTANT.EMPTY_ISSUE_COLLECTOR_CONFIG:
            return {
                ...state,
                issueConfig: {
                    ...state.issueConfig,
                    config: {}
                }
            }
        case ISSUE_CONSTANT.CHANGE_DESCRIPTION_TITLE:
            return {
                ...state,
                issueConfig: {
                    ...state.issueConfig,
                    config: {
                        ...state.issueConfig.config,
                        descriptiontitle: action.descriptiontitle
                    }
                }
            }
        case ISSUE_CONSTANT.CHANGE_ISSUE_TITLE:
            return {
                ...state,
                issueConfig: {
                    ...state.issueConfig,
                    config: {
                        ...state.issueConfig.config,
                        issuetitle: action.issuetitle
                    }
                }
            }
        case ISSUE_CONSTANT.CHANGE_INTRODUCTION_TEXT:
            return {
                ...state,
                issueConfig: {
                    ...state.issueConfig,
                    config: {
                        ...state.issueConfig.config,
                        introductiontext: action.introductiontext
                    }
                }
            }
        case ISSUE_CONSTANT.CHANGE_SCREEN_TITLE:
            return {
                ...state,
                issueConfig: {
                    ...state.issueConfig,
                    config: {
                        ...state.issueConfig.config,
                        screentitle: action.screentitle
                    }
                }
            }
        case ISSUE_CONSTANT.IS_ATTACHMENT_AVAILABLE:
            return {
                ...state,
                issueConfig: {
                    ...state.issueConfig,
                    config: {
                        ...state.issueConfig.config,
                        isattachmentavailable: action.isavailable
                    }
                }
            }
        case ISSUE_CONSTANT.RESET_ISSUE_CONFIG:
            return {
                ...state,
                issueConfig: {
                    ...state.issueConfig,
                    config: action.config,
                    reloadForm: !state.issueConfig.reloadForm                    
                }
            }
        case APP_CONSTANT.TOGGLE_MORE_INSTRUCTION:
            return {
                ...state,
                issueConfig: {
                    ...state.issueConfig,
                    toggleMoreInstruction: !state.issueConfig.toggleMoreInstruction
                }
            }
        default:
            return state;
    }
};

export default IssueConfigReducer;